export default __webpack_public_path__ + "static/media/tech-starter.f15dabe5.png";